"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = NSMerchButtonSet;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _siblingSet = _interopRequireDefault(require("@ux/sibling-set"));
var _button = _interopRequireDefault(require("./button.js"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireWildcard(require("react"));
var _patternLibraryUtils = require("@site/pattern-library-utils");
var _core = require("@linaria/core");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const buttonStyles = "core-b13z7tp";

/**
  * Render action buttons
  *
  * @param {Object} props React props for for element
  * @param {Object[]} props.buttons UXCore Button props
  * @returns {React.ReactElement} UXCore ButtonSet component
  * @public
  */
function NSMerchButtonSet({
  buttons,
  templateMap = {},
  ...siblingSetProps
}) {
  return /*#__PURE__*/_react.default.createElement(_siblingSet.default, (0, _extends2.default)({}, siblingSetProps, {
    wrap: true,
    className: buttonStyles,
    "data-cy": "ns-merch-button-set"
  }), buttons && (0, _patternLibraryUtils.filterNull)(buttons).map(({
    templateName = null,
    ...button
  }, i) => {
    const key = `cta-${i}`;
    if (/*#__PURE__*/(0, _react.isValidElement)(button)) {
      return button;
    }
    const templateComponentMap = {
      'Button Component': _button.default,
      ...templateMap
    };
    const Button = templateComponentMap[templateName ?? 'Button Component'];
    return Button && /*#__PURE__*/_react.default.createElement(Button, (0, _extends2.default)({
      key: key
    }, button));
  }));
}
NSMerchButtonSet.propTypes = {
  buttons: _propTypes.default.array.isRequired,
  templateMap: _propTypes.default.object,
  ..._siblingSet.default.propTypes
};